import { useContext } from 'react'

import EventDetailsContext from '../../context/EventDetails/EventDetails'
import { DynamicPricingWrapper } from '../../components/DynamicPricingWrapper'

/**
 * DynamicPricingPage
 *
 * Lives inside the /event/:uuid route tree.  MyEventPage provides the event
 * via EventDetailsContext (not outlet context), matching the same pattern
 * used by DashboardPage, EventDetailsPage, etc.
 */
export default function DynamicPricingPage() {
  const { event } = useContext(EventDetailsContext)

  const pricingObjectNames = event?.pricingLevels
    ? Object.values(event.pricingLevels)
        .map((pl) => pl.name)
        .filter(Boolean)
    : []

  return (
    <DynamicPricingWrapper
      event={event}
      pricingObjectNames={pricingObjectNames}
    />
  )
}
